import type { AppState } from "../../../@types/context";

/** we'll get a TypeScript error if there is an ActionType not represented in the reducer. */
export function exhaustiveGuard(type: never, state: AppState): never {
  throw new Error(`Reducer missing handler for:
        ACTION: ${type}
        STATE: ${JSON.stringify(state, null, 2)}`);
}
